import { create } from "@storybook/theming";
import Link from "./components/Link";

const brand = {
	brandTitle: "Unboared",
	brandUrl: "https://github.com/unboared/ui",
	brandImage: "/images/logo-name.png",
	fontBase:
		'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
};

export const light = create({
	base: "light",
	...brand,
	colorPrimary: "#FF2453",
	colorSecondary: "#FF2453AA",
	appBg: "#FFFFFF",
});

export const dark = create({
	base: "dark",
	...brand,
	colorPrimary: "#FF2453",
	colorSecondary: "#FF2453AA",
	appBg: "#070219",
});

export function getTheme(prefersDark: boolean) {
	return prefersDark ? dark : light;
}

export const components = {
	a: Link,
};
